module.exports = window["wcPPCP"]["cart"];